import Vue from 'vue';
import Router from 'vue-router';
import { setOrigin, getOriginFrom, getShareFrom } from 'ym-reporter-vue';
import store from '@/store';
import {
  setAuth,
  getAuth,
  isAppWebView,
  setWebViewAuth,
  generateUrl,
  locationHref,
  getAppRouteMap,
  parseQuery,
  getBaseUrl,
} from '@/utils';
import { getUserLoginWithToken, getUserLoginWithQueryToken } from '@/services/user';
import {
  TOKEN_NAME,
  MINI_PROGRAM_TOKEN_NAME,
  APP_TOKEN_NAME,
  APP_ROUTE_TOKEN_WHITE_LIST,
} from '@/utils/constant';
import reloadPage from '@/utils/reload';
import { setWechatConfig, updateWechatShareInfo } from '@/utils/share';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/marketing',
      name: 'Marketing',
      component: () => import('@/layout/RouterView').catch(reloadPage),
      children: [
        {
          path: '2019',
          name: 'Marketing2019',
          component: () => import('@/layout/RouterView').catch(reloadPage),
          children: [
            {
              path: 'tour/lottery/join',
              name: 'Marketing2019TourLotteryJoin',
              component: () => import('@/pages/2019/TourLottery/PMD/Join').catch(reloadPage),
            },
            {
              path: 'tour/lottery/assist',
              name: 'Marketing2019TourLotteryAssist',
              component: () => import('@/pages/2019/TourLottery/PMD/Assist').catch(reloadPage),
            },
            {
              path: 'mother/day',
              name: 'Marketing2019MotherDay',
              component: () => import('@/pages/2019/MotherDay/PMD').catch(reloadPage),
            },
            {
              path: 'museum/day',
              name: 'Marketing2019MuseumDay',
              component: () => import('@/pages/2019/MuseumDay/PMD').catch(reloadPage),
            },
            {
              path: 'national/day/project',
              name: 'Marketing2019NationalDay',
              component: () => import('@/pages/2019/NationalDayProject').catch(reloadPage),
            },
            {
              path: 'autumn/course',
              name: 'AutumnCourse',
              component: () => import('@/pages/2019/AutumnCourse').catch(reloadPage),
            },
            {
              path: 'oct/course',
              name: 'OctoberCourse',
              component: () => import('@/pages/2019/OctoberCourse').catch(reloadPage),
            },
            {
              path: 'nov/course',
              name: 'NovemberCourse',
              component: () => import('@/pages/2019/NovemberCourse').catch(reloadPage),
            },
            {
              path: 'scholarship/plan',
              name: 'ScholarshipPlan',
              component: () => import('@/pages/2019/ScholarshipPlan').catch(reloadPage),
            },
            {
              path: 'liuxuan/test',
              name: 'LiuXuanTest',
              component: () => import('@/pages/2019/LiuXuanTest').catch(reloadPage),
            },
            {
              path: 'birthday',
              name: 'Birthday',
              component: () => import('@/pages/2019/Birthday').catch(reloadPage),
            },
            {
              path: 'birthday/inform/me',
              name: 'BirthdayInformMe',
              component: () => import('@/pages/2019/Birthday/InformMe').catch(reloadPage),
            },
          ],
        },
        {
          path: '2020',
          name: 'Marketing2020',
          component: () => import('@/layout/RouterView').catch(reloadPage),
          children: [
            {
              path: 'spring/course',
              name: 'SpringCourse',
              component: () => import('@/pages/2020/SpringCourse').catch(reloadPage),
            },
            {
              path: 'vip/day',
              name: 'VipDay',
              component: () => import('@/pages/2020/VipDay/index').catch(reloadPage),
              meta: { showConsult: false },
            },
            {
              path: 'vip/day/:month(\\d+)',
              name: 'VipDay',
              component: () => import('@/pages/2020/VipDay/index').catch(reloadPage),
              meta: { showConsult: false },
            },
            {
              path: 'wish/bottle',
              name: 'WishBottle',
              component: () => import('@/pages/2020/WishBottle/index').catch(reloadPage),
              meta: { showConsult: false },
            },
            {
              path: 'may/course',
              name: 'MayCourse',
              component: () => import('@/pages/2020/MayCourse').catch(reloadPage),
            },
            {
              path: 'world/reading/day',
              name: 'WorldReadingDay',
              component: () => import('@/pages/2020/WorldReadingDay').catch(reloadPage),
            },
            {
              path: 'children/day',
              name: 'ChildrenDay',
              component: () => import('@/pages/2020/ChildrenDay').catch(reloadPage),
            },
            {
              path: '618',
              name: 'KnowledgeCarnival',
              component: () => import('@/pages/2020/KnowledgeCarnival').catch(reloadPage),
            },
            {
              path: 'turn/over',
              name: 'TurnOver',
              component: () => import('@/pages/2020/TurnOver').catch(reloadPage),
            },
            {
              path: 'turn/over/share',
              name: 'TurnOverShare',
              component: () => import('@/pages/2020/TurnOver/TurnOverShare').catch(reloadPage),
            },
            {
              path: 'learn/ability/test',
              name: 'LearnAbilityTest',
              component: () => import('@/pages/2020/LearnAbilityTest').catch(reloadPage),
            },
            // 周年庆 主会场
            {
              path: 'birthday',
              name: 'Birthday2020',
              component: () => import('@/pages/2020/Birthday').catch(reloadPage),
            },
            // 周年庆 主题学习包分会场
            {
              path: 'birthday/combo',
              name: 'BirthdayCombo2020',
              component: () => import('@/pages/2020/Birthday/ComboList').catch(reloadPage),
            },
            // 周年庆 直播课分会场
            {
              path: 'birthday/course',
              name: 'BirthdayCourse2020',
              component: () => import('@/pages/2020/Birthday/CourseList').catch(reloadPage),
            },
            // 周年庆 实物分会场
            {
              path: 'birthday/entity',
              name: 'BirthdayProject2020',
              component: () => import('@/pages/2020/Birthday/EntityList').catch(reloadPage),
            },
            // 成长报告主页
            {
              path: 'growth/report',
              name: 'GrowthReport',
              component: () => import('@/pages/2020/GrowthReport').catch(reloadPage),
            },
          ],
        },
        {
          path: '2021',
          name: 'Marketing2021',
          component: () => import('@/layout/RouterView').catch(reloadPage),
          children: [
            {
              path: 'public/welfare',
              name: 'PublicWelfare',
              component: () => import('@/pages/2021/PublicWelfare').catch(reloadPage),
            },
            {
              path: 'public/welfare/rule',
              name: 'PublicWelfareRule',
              component: () => import('@/pages/2021/PublicWelfare/PublicWelfareRule').catch(reloadPage),
            },
            {
              path: 'public/welfare/success',
              name: 'PublicWelfareSuccess',
              component: () => import('@/pages/2021/PublicWelfare/PublicWelfareSuccess').catch(reloadPage),
            },
            {
              path: 'public/welfare/relay',
              name: 'PublicWelfareRelay',
              component: () => import('@/pages/2021/PublicWelfare/PublicWelfareRelay').catch(reloadPage),
            },
            {
              path: 'reading/day',
              name: 'ReadingDay',
              component: () => import('@/pages/2021/ReadingDay').catch(reloadPage),
            },
            {
              path: 'reading/day/group',
              name: 'ReadingDayGroup',
              component: () => import('@/pages/2021/ReadingDay/ReadingDayGroup').catch(reloadPage),
            },
            {
              path: 'reading/day/audio',
              name: 'ReadingDayAudio',
              component: () => import('@/pages/2021/ReadingDay/ReadingDayAudio').catch(reloadPage),
            },
            {
              path: 'reading/day/project',
              name: 'ReadingDayProject',
              component: () => import('@/pages/2021/ReadingDay/ReadingDayProject').catch(reloadPage),
            },
            {
              path: 'children/day',
              name: 'ChildrenDay',
              component: () => import('@/pages/2021/ChildrenDay').catch(reloadPage),
            },
            {
              path: 'summer/pre/sale',
              name: 'SummerPreSale',
              component: () => import('@/pages/2021/SummerPreSale').catch(reloadPage),
            },
            {
              path: 'birthday',
              name: 'Birthday2021',
              component: () => import('@/pages/2021/Birthday').catch(reloadPage),
            },
          ],
        },
      ],
    },
    {
      path: '/marketing/common/activity/:type(\\w+)',
      name: 'DefaultActivity',
      component: () => import('@/pages/DefaultActivityPage').catch(reloadPage),
    },
    {
      path: '/500',
      name: 'Error500',
      component: () => import('@/pages/Error/500').catch(reloadPage),
    },
    {
      path: '/403',
      name: 'Error403',
      component: () => import('@/pages/Error/403').catch(reloadPage),
    },
    {
      path: '/404',
      name: 'Error404',
      component: () => import('@/pages/Error/404').catch(reloadPage),
    },
  ],
});

const inWebView = isAppWebView();
const appRouteMap = getAppRouteMap();
let isLandingPage = true;


/**
 * 更新token
 * @param to
 * @returns {Promise<any>}
 */
function updateToken(to) {
  return new Promise(async (resolve, reject) => {
    // 获取URI query 中的token 进行登录
    const { query } = to;
    const {
      [TOKEN_NAME]: mWApiToken,
      [MINI_PROGRAM_TOKEN_NAME]: miniToken,
      [APP_TOKEN_NAME]: mApiToken,
    } = query;
    if (mWApiToken || miniToken || mApiToken) {
      // 清空当前登录用户信息
      setAuth('');
      try {
        // 尝试使用query token 登录
        await getUserLoginWithQueryToken({
          mWApiToken,
          miniToken,
          mApiToken,
        });
        return resolve();
      } catch (e) {
        console.log('e', e);
        return reject(new Error('getUserLoginWithQueryTokenError'));
      }
    }
    return resolve();
  });
}

/**
 * 构建页面来源数据
 * @returns {{}}
 */
function buildPageSource() {
  const result = {};
  // 增加数据来源打点
  const origin = getOriginFrom();
  const ymsf = getShareFrom();
  if (origin !== '') {
    result.origin = origin;
  }
  if (ymsf !== '') {
    result.ymsf = ymsf;
  }
  return result;
}

/**
 * 生成App 路由
 * @param appPath
 * @param to
 * @param auth
 * @returns {Promise<string>}
 */
async function generateAppRoute(appPath, to, auth) {
  const { name, params, query } = to;
  // 增加数据来源打点
  const pageSource = buildPageSource();
  const appPathOptions = Object.assign(query, params, pageSource);
  // 处理token 逻辑
  setWebViewAuth(auth);
  // @todo issa iOS 两个版后删除Query token
  // 在token 白名单内才添加token
  if (APP_ROUTE_TOKEN_WHITE_LIST.includes(name)) {
    appPathOptions[TOKEN_NAME] = auth;
  }
  // 生成URL
  return generateUrl(appPath, appPathOptions);
}

router.beforeEach(async (to, from, next) => {
  const extraLinkIndex = to.fullPath.search(/http(s):\/\//);
  if (extraLinkIndex !== -1) {
    let href = to.fullPath.slice(extraLinkIndex, to.fullPath.length);
    // 处理App webview 市场活动跳转官网H5 逻辑
    if (inWebView) {
      let query = parseQuery(href);
      // query 中增加webview 次数为2，作为标志
      query = Object.assign(
        {},
        query,
        { webviewcount: '2' },
      );
      const baseUrl = getBaseUrl(href);
      href = generateUrl(baseUrl, query);
    }
    window.location.href = href;
    return;
  }

  if (!to.matched || to.matched.length === 0) {
    next({ name: 'Error404', replace: true });
    return;
  }

  // 获取本地缓存用户验证
  let auth = getAuth();

  // 处理App web view
  if (inWebView) {
    if (isLandingPage) {
      // 更新token
      await updateToken(to);
      // 更新用户验证
      auth = getAuth();
      isLandingPage = false;
      next();
      return;
    }
    const { name } = to;
    const route = appRouteMap.find(item => item.name === name);
    if (route) {
      const { appPath } = route;
      const url = await generateAppRoute(appPath, to, auth);
      locationHref(url);
      return;
    }
  }

  // 处理404
  if (!to.matched || to.matched.length === 0) {
    next({ name: 'Error404', replace: true });
    return;
  }

  // 更新token
  await updateToken(to);
  // 更新用户验证
  auth = getAuth();

  // 获取是否新建App
  const { newApp } = store.getters;
  if (newApp && auth === '') {
    // 尝试登录
    await getUserLoginWithToken();
    // 设置当前单页应用非新建
    store.dispatch('toggleNewApp', false);
  }

  // 处理需要登录才能浏览的页面
  const { meta } = to;
  if (meta && meta.auth) {
    if (!auth || auth === '') {
      const { fullPath } = to;
      next({ name: 'Login', query: { redirectTo: fullPath }, replace: true });
      return;
    }
  }

  // 获取URI query 中的token 进行登录
  const { query } = to;
  const {
    [TOKEN_NAME]: mWApiToken,
    [MINI_PROGRAM_TOKEN_NAME]: miniToken,
    [APP_TOKEN_NAME]: mApiToken,
  } = query;
  if (mWApiToken || miniToken || mApiToken) {
    // 清空当前登录用户信息
    setAuth('');
    // 尝试使用query token 登录
    await getUserLoginWithQueryToken({
      mWApiToken,
      miniToken,
      mApiToken,
    });
  }
  next();
});

function setBackText(backName) {
  const { backText } = store.getters;
  if (backName === 'Home' && backText !== '首页') {
    store.dispatch('changeBackText', '首页');
    return;
  }
  if (backText !== '') {
    store.dispatch('changeBackText', '');
  }
}

router.afterEach((to) => {
  const { meta = {} } = to;
  const { back, tab } = meta;
  const backName = back ? back.name : '';
  setBackText(backName);
  Promise.resolve().then(() => {
    // 每次页面切换，更新origin 存活时间
    setOrigin();
    // 事件埋点上报页面
    Vue.prototype.$reporter.reportPage();

    // 处理返回按钮展示
    store.dispatch('toggleShowBack', !tab);
    // 设置微信配置
    setWechatConfig();
    // 更新微信分享信息
    updateWechatShareInfo();
  });
});

export default router;
